import Vue from "vue";
import websocket from "@/utils/websocket/index";
import http from "@/api/api";
import store from "@/store/index";

//TODO:获取后端验证码
export const getCodeAn = async () => {
  let res = await http.get("/code");
  return res;
};

//获取第三方用户信息
export const getLoginUser = async (token) => {
  localStorage.setItem("Authorization", `${token}`);

  let res = await http.get(`/tenant/zlUser/abutment/login?token=${token}`);
  if (res.code == 200) {
    localStorage.setItem("user", JSON.stringify(res.data));
    // 本地保存token
    localStorage.setItem("tenantId",res.data.tenantId);
    //存到vuex
    store.commit("uploginUser", res.data);

    // TODO: WebSocket 通过单例模式连接ws服务器：
    const wsInstance = websocket.Instance;
    wsInstance.newvue = this;
    // TODO: WebSocket 将websocket挂载到vue原型上：
    Vue.prototype.$ws = wsInstance;

    // 连接WebSocket
    wsInstance.connect(res.data.id);
  } else {
    // this.$hideLoading(); //关闭加载器

    //跳转到http://120.79.47.146:20806/#/login?ExternalLinks=http://192.168.2.2:9600/#/

    // window.location.href = `http://120.79.47.146:20806/#/login?ExternalLinks=http://192.168.2.2:9600/#/`;
    // 清除 localStorage 中的特定项
    const itemsToKeep = ["layout-setting"]; // 需要保留的项
    const keysToRemove = Object.keys(localStorage).filter(
      (key) => !itemsToKeep.includes(key)
    );
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    // localStorage.clear(); //移除所有缓存

    //跳转到主系统登录页
    // window.location.href = `http://120.79.47.146:20806`; 
  }

  return res;
};

//登陆
export const login = async (userInfo) => {
  let res = await http.post("/auth/tenant/login", userInfo);
  console.log(res);
  if (res.code == 200) {
    localStorage.setItem("user", JSON.stringify(res.data.user.safeTenantUser));
    localStorage.setItem("Authorization", `${res.data.access_token}`);
    // 本地保存token
    localStorage.setItem(
      "tenantId",
      res.data.user.safeTenantUser.tenantId
    );
    //存到vuex
    store.commit("uploginUser", res.data.user.safeTenantUser);
    // TODO: WebSocket 通过单例模式连接ws服务器：
    const wsInstance = websocket.Instance;
    wsInstance.newvue = this;
    // TODO: WebSocket 将websocket挂载到vue原型上：
    Vue.prototype.$ws = wsInstance;

    // 连接WebSocket
    wsInstance.connect(res.data.user.safeTenantUser.id);
  } else {
    // this.$hideLoading(); //关闭加载器
  }

  return res;
};
